import {Map, List} from 'immutable';
import {createSelector} from 'reselect';

export const getApp = state => state.get('app');
export const getAppReady = createSelector([getApp], app => app.get('ready', false));
export const getAppUuid = createSelector([getApp], app => app.get('uuid', ''));
export const getAppOnline = createSelector([getApp], app => app.get('online', 0));
export const getSettings = createSelector([getApp], app => app.getIn(['settings','data'], List([])).toJS());
export const getSettingsState = createSelector([getApp], app => app.get('settings', Map({})));
export const getMomentTimezone = state => state.getIn(['app','momentTimezone']).clone();
export const getMomentTimezoneOffset = state => state.getIn(['app','momentTimezoneOffset']).clone();

export const getBook = state => state.get('book');
export const getBookDate = createSelector([getBook], book => book.get('date'));
export const getBookForm = createSelector([getBook], book => book.get('form'));
export const getTables = createSelector([getBook], book => book.get('tables'));
export const getIntervals = createSelector([getBook], book => book.get('intervals'));
export const getBookings = createSelector([getBook], book => book.get('bookings'));
export const getMyBookings = createSelector([getBook], book => book.get('my_bookings'));
export const getSwipeStatus = createSelector([getBook], book => book.get('swipe'));

export const getSelected = createSelector([getBook], book => book.get('selected'));
export const getSelectedTableId = createSelector([getSelected], selected => selected.get('table_id'));
export const getSelectedIntervals = createSelector([getSelected], selected => selected.get('intervals').toJS());

export const getLocation = state => state.getIn(['router','location'], List([])).toJS();

export const getReview = state => state.get('review');
export const getReviewForm = createSelector([getReview], review => review.get('form'));

export const getCard = state => state.get('card');
export const getCardCreateForm = createSelector([getCard], card => card.get('createForm'));
export const getCardFindForm = createSelector([getCard], card => card.get('findForm'));
export const getCardInfo = createSelector([getCard], card => card.get('info', Map({})).toJS());



// WEBPACK FOOTER //
// ./src/selectors/index.js